import { ReactElement, useContext, useEffect, useState } from "react";

import { Category } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { CategoryContext } from "../../../providers/category-provider";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChange(category: Category): void;
};

export default function AssetCategorySelector(props: Props): ReactElement {
  const { onChange } = props;

  const { strings } = useText(local);

  const [categories, setCategoryies] = useState<Category[]>([]);
  const { categories: globalCategories } = useContext(CategoryContext);

  useEffect(() => {
    setCategoryies(globalCategories.filter((item) => !item.parentId));
  }, [globalCategories]);

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={categories}
      setOption={(v) => onChange(v["value"])}
      // searchById={handleSearchFamily}
      list={categories.map((v) => ({ text: v.name, value: v }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Asset Category",
  },
};
